import zhTw from './locales/zh-TW-widget.json'
import ja from './locales/ja-widget.json'
import ko from './locales/ko-widget.json'
import { normalizeLocale } from './locales'

const dictionaries: Record<string, Record<string, string>> = { 'zh-TW': zhTw, ja, ko }

/** Shared copy for native PiP renderers, which do not have a Vue i18n context. */
export function widgetCopy<T>(locale: string, english: T, chinese: T): T {
  const language = normalizeLocale(locale)
  if (language === 'zh-CN') return chinese
  if (language === 'en') return english
  const translate = (value: unknown): unknown => {
    if (typeof value === 'string') return dictionaries[language]?.[value] ?? value
    if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, translate(item)]))
    return value
  }
  return translate(english) as T
}

export function widgetText(locale: string, english: string, chinese: string, values: Record<string, unknown>): string {
  return widgetCopy(locale, english, chinese).replace(/\{(\w+)\}/g, (match, key: string) => String(values[key] ?? match))
}
